import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import ChatWidget from '../common/ChatWidget';
import { platformAPI, fileUrl } from '../../services/api';
import { LandingHeader, LandingFooter } from '../landing/LandingChrome';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .contact-page {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    -webkit-font-smoothing: antialiased;
  }
  .contact-page * { box-sizing: border-box; }

  .contact-hero {
    position: relative;
    padding: 80px 24px 60px;
    text-align: center;
    overflow: hidden;
    background: linear-gradient(135deg, #1e3a5f 0%, #0ea5e9 100%);
  }
  .contact-hero::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: radial-gradient(ellipse at 30% 50%, rgba(255,255,255,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
  .contact-hero::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 1px;
    background: rgba(255,255,255,0.15);
  }
  .contact-hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.12);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255,255,255,0.15);
    border-radius: 100px;
    padding: 6px 16px;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255,255,255,0.9);
    letter-spacing: 0.05em;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .contact-hero h1 {
    margin: 0 0 12px;
    font-size: 44px;
    font-weight: 900;
    color: #fff;
    letter-spacing: -0.02em;
    line-height: 1.1;
  }
  .contact-hero-subtitle {
    margin: 0 auto;
    font-size: 17px;
    color: rgba(255,255,255,0.75);
    max-width: 620px;
    line-height: 1.6;
    font-weight: 400;
  }

  .contact-grid {
    max-width: 1100px;
    margin: 0 auto;
    padding: 48px 24px 80px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: start;
  }

  .contact-form-card {
    background: #fff;
    border-radius: 16px;
    padding: 40px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 24px rgba(0,0,0,0.02);
    border: 1px solid #e2e8f0;
  }
  .contact-form-card h2 {
    margin: 0 0 6px;
    font-size: 22px;
    font-weight: 800;
    color: #0f172a;
  }
  .contact-form-card p.form-subtitle {
    margin: 0 0 24px;
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
  }
  .contact-form-group {
    margin-bottom: 18px;
  }
  .contact-form-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 6px;
  }
  .contact-form-input,
  .contact-form-textarea,
  .contact-form-select {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    color: #1e293b;
    background: #fff;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
  }
  .contact-form-input:focus,
  .contact-form-textarea:focus,
  .contact-form-select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
  }
  .contact-form-textarea {
    min-height: 120px;
    resize: vertical;
  }
  .contact-form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }
  .contact-form-submit {
    width: 100%;
    padding: 12px 24px;
    background: #0f172a;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s, transform 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  .contact-form-submit:hover { background: #1e293b; }
  .contact-form-submit:active { transform: scale(0.98); }
  .contact-form-submit:disabled { opacity: 0.6; cursor: not-allowed; }

  .contact-info-panel {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .contact-info-card {
    background: #fff;
    border-radius: 16px;
    padding: 28px 32px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 24px rgba(0,0,0,0.02);
    border: 1px solid #e2e8f0;
  }
  .contact-info-card h3 {
    margin: 0 0 16px;
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .contact-detail-row {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 12px 0;
    border-bottom: 1px solid #f1f5f9;
  }
  .contact-detail-row:last-child { border-bottom: none; }
  .contact-detail-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #eff6ff;
    color: #2563eb;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .contact-detail-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 2px;
  }
  .contact-detail-value {
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.4;
  }
  .contact-detail-value a {
    color: #2563eb;
    text-decoration: none;
  }
  .contact-detail-value a:hover { text-decoration: underline; }


  /* FAQ section */
  .contact-faq {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 24px 80px;
  }
  .contact-faq h2 {
    text-align: center;
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 8px;
  }
  .contact-faq-subtitle {
    text-align: center;
    font-size: 15px;
    color: #64748b;
    margin: 0 0 40px;
  }
  .faq-item {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;
    transition: box-shadow 0.2s;
  }
  .faq-item:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.04); }
  .faq-question {
    padding: 18px 24px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 600;
    color: #0f172a;
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    font-family: inherit;
  }
  .faq-question:hover { background: #fafbfc; }
  .faq-chevron {
    transition: transform 0.2s;
    color: #94a3b8;
    flex-shrink: 0;
  }
  .faq-chevron.open { transform: rotate(180deg); }
  .faq-answer {
    padding: 0 24px 18px;
    font-size: 14px;
    color: #475569;
    line-height: 1.7;
  }

  /* Bottom CTA */
  .contact-cta {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 24px 80px;
  }
  .contact-cta-card {
    background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%);
    border-radius: 20px;
    padding: 48px;
    text-align: center;
    color: #fff;
  }
  .contact-cta-card h2 {
    margin: 0 0 10px;
    font-size: 26px;
    font-weight: 800;
  }
  .contact-cta-card p {
    margin: 0 0 24px;
    font-size: 15px;
    color: rgba(255,255,255,0.7);
  }
  .contact-cta-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }
  .contact-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 28px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    transition: all 0.2s;
  }
  .contact-cta-btn-primary {
    background: #2563eb;
    color: #fff;
  }
  .contact-cta-btn-primary:hover { background: #1d4ed8; }
  .contact-cta-btn-secondary {
    background: rgba(255,255,255,0.1);
    color: #fff;
    border: 1px solid rgba(255,255,255,0.2);
  }
  .contact-cta-btn-secondary:hover { background: rgba(255,255,255,0.15); }

  @media (max-width: 768px) {
    .contact-hero { padding: 60px 20px 40px; }
    .contact-hero h1 { font-size: 32px; }
    .contact-hero-subtitle { font-size: 15px; }
    .contact-grid { grid-template-columns: 1fr; padding: 24px 16px 60px; gap: 24px; }
    .contact-form-card { padding: 24px 20px; }
    .contact-form-row { grid-template-columns: 1fr; }
    .contact-info-card { padding: 20px; }
    .contact-faq { padding: 0 16px 60px; }
    .contact-cta { padding: 0 16px 60px; }
    .contact-cta-card { padding: 32px 20px; }
  }
`;

const FAQ_DATA = [
  {
    q: 'How do I get started with LedgerPro?',
    a: 'Getting started is easy! Simply create an account on our registration page, choose a subscription plan that fits your business needs, and you can begin using LedgerPro immediately. Our onboarding wizard will guide you through setting up your company profile, chart of accounts, and initial data import.',
  },
  {
    q: 'What subscription plans do you offer?',
    a: 'LedgerPro offers flexible subscription plans designed for businesses of all sizes. We provide monthly and annual billing options with features ranging from basic invoicing to full-suite accounting with multi-user access, inventory management, and advanced reporting. Visit our pricing page or contact sales for detailed plan comparisons.',
  },
  {
    q: 'Can I import data from other accounting software?',
    a: 'Yes! LedgerPro supports importing data from popular accounting platforms including QuickBooks, Xero, Wave, and generic CSV/Excel files. Our import wizard handles customers, vendors, products, invoices, bills, journal entries, and chart of accounts. Our support team can assist with complex migrations.',
  },
  {
    q: 'Is my financial data secure?',
    a: 'Absolutely. Security is our top priority. All data is encrypted in transit (TLS 1.2+) and at rest (AES-256). We use bcrypt password hashing, role-based access controls, regular backups, and SOC 2-compliant hosting infrastructure. For full details, visit our Security page.',
  },
  {
    q: 'Do you offer a free trial?',
    a: 'Yes, we offer a 14-day free trial on all subscription plans. No credit card is required to start your trial. You can explore all features of your chosen plan during the trial period. If you decide not to continue, your trial will simply expire with no charges.',
  },
  {
    q: 'Can I cancel my subscription at any time?',
    a: 'Yes, you can cancel your subscription at any time through your account settings. Your access continues until the end of your current billing period. Annual subscribers may request a prorated refund within 14 days of renewal. All your data remains available for export for 30 days after cancellation.',
  },
  {
    q: 'Do you provide customer support?',
    a: 'Yes, we provide comprehensive customer support via email, live chat, and phone during business hours. Premium and Enterprise plans include priority support with faster response times. Our knowledge base and video tutorials are available 24/7 for self-service assistance.',
  },
  {
    q: 'Is LedgerPro suitable for my industry?',
    a: 'LedgerPro is designed for a wide range of industries including retail, wholesale, professional services, freelancers, startups, nonprofits, and general businesses. Our flexible chart of accounts, customizable invoicing, and comprehensive reporting make it adaptable to virtually any business that needs accounting and financial management.',
  },
];

function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', company: '', phone: '', subject: 'general', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill in all required fields');
      return;
    }
    setLoading(true);
    try {
      // Try sending via email API
      const res = await fetch((process.env.REACT_APP_API_URL || '/api') + '/platform/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      toast.success('Message sent! We\'ll get back to you within 24 hours.');
      setForm({ name: '', email: '', company: '', phone: '', subject: 'general', message: '' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="contact-form-row">
        <div className="contact-form-group">
          <label className="contact-form-label">Full Name *</label>
          <input className="contact-form-input" type="text" placeholder="John Doe" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
        </div>
        <div className="contact-form-group">
          <label className="contact-form-label">Email Address *</label>
          <input className="contact-form-input" type="email" placeholder="john@company.com" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
        </div>
      </div>
      <div className="contact-form-row">
        <div className="contact-form-group">
          <label className="contact-form-label">Company</label>
          <input className="contact-form-input" type="text" placeholder="Company Name" value={form.company} onChange={e => setForm({...form, company: e.target.value})} />
        </div>
        <div className="contact-form-group">
          <label className="contact-form-label">Phone</label>
          <input className="contact-form-input" type="tel" placeholder="+1 (555) 000-0000" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
        </div>
      </div>
      <div className="contact-form-group">
        <label className="contact-form-label">Subject</label>
        <select className="contact-form-select" value={form.subject} onChange={e => setForm({...form, subject: e.target.value})}>
          <option value="general">General Inquiry</option>
          <option value="sales">Sales & Pricing</option>
          <option value="support">Technical Support</option>
          <option value="billing">Billing & Payments</option>
          <option value="partnership">Partnership Opportunities</option>
          <option value="feedback">Feedback & Suggestions</option>
          <option value="security">Security Vulnerability Report</option>
        </select>
      </div>
      <div className="contact-form-group">
        <label className="contact-form-label">Message *</label>
        <textarea className="contact-form-textarea" placeholder="How can we help you? Please provide as much detail as possible..." value={form.message} onChange={e => setForm({...form, message: e.target.value})} required />
      </div>
      <button type="submit" className="contact-form-submit" disabled={loading}>
        {loading ? (
          <>Sending...</>
        ) : (
          <>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>
            Send Message
          </>
        )}
      </button>
    </form>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen(!open)}>
        {q}
        <svg className={`faq-chevron ${open ? 'open' : ''}`} width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>
      </button>
      {open && <div className="faq-answer">{a}</div>}
    </div>
  );
}

const PAGE_META = {
  'privacy-policy': { navLabel: 'Privacy Policy' },
  'terms-of-service': { navLabel: 'Terms of Service' },
  'security': { navLabel: 'Security' },
  'contact': { navLabel: 'Contact' },
};

export default function ContactPage() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    platformAPI.getPublicSettings()
      .then(data => setSettings(data))
      .catch(() => {});
  }, []);

  return (
    <div className="contact-page" style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <style>{STYLES}</style>

      {/* Shared landing navbar */}
      <LandingHeader />

      {/* Hero */}
      <div className="contact-hero">
        <div className="contact-hero-badge">
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></svg>
          <span>LedgerPro Accounting System</span>
        </div>
        <h1>Contact Us</h1>
        <p className="contact-hero-subtitle">
          Have a question, need help, or want to discuss how LedgerPro can transform your business? We'd love to hear from you. Our team is ready to assist.
        </p>
      </div>

      {/* Main Grid: Form + Info */}
      <div className="contact-grid">
        {/* Contact Form */}
        <div className="contact-form-card">
          <h2>Send Us a Message</h2>
          <p className="form-subtitle">Fill out the form below and our team will get back to you within 24 hours during business days.</p>
          <ContactForm />
        </div>

        {/* Contact Info */}
        <div className="contact-info-panel">
          {/* General Inquiries */}
          <div className="contact-info-card">
            <h3>
              <svg width="18" height="18" fill="none" stroke="#2563eb" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><path d="M22 6l-10 7L2 6"/></svg>
              General Inquiries
            </h3>
            <div className="contact-detail-row">
              <div className="contact-detail-icon">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><path d="M22 6l-10 7L2 6"/></svg>
              </div>
              <div>
                <div className="contact-detail-label">Email</div>
                <div className="contact-detail-value"><a href={`mailto:${settings.support_email || 'support@ledgerpro.com'}`}>{settings.support_email || 'support@ledgerpro.com'}</a></div>
              </div>
            </div>
            <div className="contact-detail-row">
              <div className="contact-detail-icon">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              </div>
              <div>
                <div className="contact-detail-label">Phone</div>
                <div className="contact-detail-value"><a href={`tel:${settings.company_phone || '+1-800-LEDGER-PRO'}`}>{settings.company_phone || '+1 (800) 533-4377'}</a></div>
              </div>
            </div>
            <div className="contact-detail-row">
              <div className="contact-detail-icon">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </div>
              <div>
                <div className="contact-detail-label">Office</div>
                <div className="contact-detail-value">{settings.company_address || 'Rahkar Hoshmand, Afghanistan'}</div>
              </div>
            </div>
          </div>

          {/* Support */}
          <div className="contact-info-card">
            <h3>
              <svg width="18" height="18" fill="none" stroke="#059669" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><circle cx="12" cy="17" r=".5"/></svg>
              Technical Support
            </h3>
            <div className="contact-detail-row">
              <div className="contact-detail-icon" style={{ background: '#f0fdf4', color: '#059669' }}>
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><path d="M22 6l-10 7L2 6"/></svg>
              </div>
              <div>
                <div className="contact-detail-label">Support Email</div>
                <div className="contact-detail-value"><a href={`mailto:${settings.support_email || 'support@ledgerpro.com'}`}>{settings.support_email || 'support@ledgerpro.com'}</a></div>
              </div>
            </div>
            <div className="contact-detail-row">
              <div className="contact-detail-icon" style={{ background: '#fef3c7', color: '#d97706' }}>
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
              </div>
              <div>
                <div className="contact-detail-label">Response Time</div>
                <div className="contact-detail-value">Within 24 hours on business days</div>
              </div>
            </div>
            <div className="contact-detail-row">
              <div className="contact-detail-icon" style={{ background: '#faf5ff', color: '#7c3aed' }}>
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><circle cx="12" cy="17" r=".5"/></svg>
              </div>
              <div>
                <div className="contact-detail-label">Knowledge Base</div>
                <div className="contact-detail-value"><a href="/login">Help Center &amp; Documentation</a></div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom CTA */}
      <div className="contact-cta">
        <div className="contact-cta-card">
          <h2>Ready to Transform Your Accounting?</h2>
          <p>Join thousands of businesses using LedgerPro to manage their finances efficiently and professionally.</p>
          <div className="contact-cta-buttons">
            <Link to="/register" className="contact-cta-btn contact-cta-btn-primary">
              Start Free Trial
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </Link>
            <Link to="/login" className="contact-cta-btn contact-cta-btn-secondary">
              Sign In to Your Account
            </Link>
          </div>
        </div>
      </div>

      {/* Live Chat Widget */}
      <ChatWidget />

      {/* Shared landing footer */}
      <LandingFooter />
    </div>
  );
}
